import React from 'react';
import { cn } from '../../lib/utils.js';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost';
  children: React.ReactNode;
}

export function Button({
  className,
  variant = 'default',
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center rounded-lg font-semibold transition-all",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        "min-h-11 sm:min-h-0 select-none",
        variant === 'default' && "bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-white px-6 py-2.5 shadow-sm",
        variant === 'outline' && "border-2 border-grey-300 bg-surface text-grey-700 px-4 py-2 hover:bg-grey-50 active:bg-grey-100",
        variant === 'ghost' && "text-grey-700 px-4 py-2 hover:bg-grey-100 active:bg-grey-200",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
